// CPI-1377: the launch-mode unit hold, client side.
//
// book-api owns the hold (project_unit.reserved_by_aws_user + reserved_timeout_expire_at, taken
// by GET .../pre_reserved/ for project.launchModeMinutes and released by ?clear=true). Its
// one-unit rule refuses a second hold with HTTP 412, M-Type error_launch_mode_multi, a plain
// sentence as the body and the held unit in three headers. The decisions the Reserve screen and
// the unit page make around that live here as plain functions, so they can be tested without
// rendering Form.jsx.

import qs from 'qs';
import moment from 'moment-timezone';

export const UNIT_HELD_M_TYPE = 'error_launch_mode_multi';
export const HELD_UNIT_ID_HEADER = 'M-Held-Unit-Id';
export const HELD_UNIT_REFERENCE_HEADER = 'M-Held-Unit-Reference';
export const HELD_UNTIL_HEADER = 'M-Held-Until';

const header = (headers, name) => {
  if (!headers || typeof headers.get !== 'function') return '';
  const value = headers.get(name);
  return typeof value === 'string' ? value : '';
};

// parseUnitHeldRefusal reads the refusal: the body is the sentence the pop-up shows, the held
// unit comes from the headers. The reference is percent-encoded on the wire so a non-ASCII one is
// a valid header value. An older book-api sends no headers, and the pop-up then falls back to the
// sentence with only Close.
export function parseUnitHeldRefusal(body, headers) {
  const message = typeof body === 'string' ? body.trim() : '';
  let heldUnitReference = header(headers, HELD_UNIT_REFERENCE_HEADER);
  try {
    heldUnitReference = decodeURIComponent(heldUnitReference);
  } catch (e) {
    // not percent-encoded after all: shown as sent
  }
  return {
    message,
    heldUnitID: header(headers, HELD_UNIT_ID_HEADER),
    heldUnitReference,
    heldUntil: header(headers, HELD_UNTIL_HEADER),
  };
}

// preReservedURL is the hold endpoint; clear releases the hold on this unit instead of taking it.
export function preReservedURL(bookApiURL, projectID, unitID, options = {}) {
  const { clear = false } = options;
  const query = {};
  if (clear) query.clear = 'true';
  return `${bookApiURL}/projects/${projectID}/units/${unitID}/pre_reserved/?${qs.stringify(query)}`;
}

// heldUnitPagePath is where "Go back to A40.07" goes: the held unit's own page.
export function heldUnitPagePath(projectID, unitID) {
  return `/projects/${projectID}/units/${unitID}/`;
}

// shouldReleaseHoldOnLeave: leaving the Reserve screen inside the app releases a LIVE hold that no
// reservation was saved against. After a save the booking owns the unit; an expired hold has
// nothing to release.
export function shouldReleaseHoldOnLeave(state, now = new Date()) {
  const { isLaunchMode, reservedTimeoutExpireAt, bookingSubmitted } = state || {};
  if (!isLaunchMode || !reservedTimeoutExpireAt || bookingSubmitted) return false;
  return moment(now).isBefore(moment(reservedTimeoutExpireAt));
}

// canForceReleaseUnitHold mirrors book-api: HQ and the platform admins may release a hold that is
// not theirs. Sales Admin, Sales Manager and agency roles may not.
export function canForceReleaseUnitHold(auth) {
  if (!auth) return false;
  return Boolean(auth.isSuperAdmin || auth.isAdmin || auth.isHeadquarters);
}



// WEBPACK FOOTER //
// ./src/utils/unitHold.js